// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__lP93g","animateThis":"Landing_animateThis__AqbdZ","span":"Landing_span__PJA6c"};